import { CommonModule, DatePipe } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  effect,
  inject,
  input,
  ChangeDetectionStrategy,
} from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SignatureRequestStatus } from '@app/features/contracts/signature/signature-request-status/signature-request-status';
import {
  getLatestSignatureRequest,
  SignatureRequest,
} from '@app/features/contracts/signature/signature-request.model';
import { LucideCalendarX, LucideCircleX, LucideRocket, LucideSignature } from '@lucide/angular';

@Component({
  selector: 'app-yousign-summary-cell',
  host: { '[class.compact]': 'compact()' },
  imports: [
    CommonModule,
    MatTooltipModule,
    SignatureRequestStatus,
    LucideRocket,
    LucideCalendarX,
    LucideSignature,
    LucideCircleX,
  ],
  templateUrl: './yousign-summary-cell.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./yousign-summary-cell.scss'],
})
export class YousignSummaryCell {
  signatureRequests = input<SignatureRequest[]>();
  /** Sur la ligne d'un avenant, l'état et ses dates tiennent sur une seule ligne. */
  compact = input<boolean>(false);
  cdr = inject(ChangeDetectorRef);
  datePipe = new DatePipe('fr-FR');

  latestSignatureRequest?: SignatureRequest;

  constructor() {
    effect(() => {
      this.latestSignatureRequest = getLatestSignatureRequest(this.signatureRequests());
      this.cdr.markForCheck();
    });
  }

  get isExpired(): boolean {
    if (!this.latestSignatureRequest) {
      return false;
    }
    const { status } = this.latestSignatureRequest;
    return status === 'expired';
  }

  get isSigned(): boolean {
    if (!this.latestSignatureRequest) {
      return false;
    }
    const { status } = this.latestSignatureRequest;
    return status === 'done';
  }
}
